"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Configuration = /*#__PURE__*/function () {
  function Configuration(service) {
    (0, _classCallCheck2["default"])(this, Configuration);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Configuration, [{
    key: "listNsFrequencyPlans",
    value: function () {
      var _listNsFrequencyPlans = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.ListFrequencyPlans({
                  component: 'ns'
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('frequency_plans', result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listNsFrequencyPlans() {
        return _listNsFrequencyPlans.apply(this, arguments);
      }

      return listNsFrequencyPlans;
    }()
  }, {
    key: "listGsFrequencyPlans",
    value: function () {
      var _listGsFrequencyPlans = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.ListFrequencyPlans({
                  component: 'gs'
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadListResponse('frequency_plans', result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listGsFrequencyPlans() {
        return _listGsFrequencyPlans.apply(this, arguments);
      }

      return listGsFrequencyPlans;
    }()
  }, {
    key: "getPhyVersions",
    value: function () {
      var _getPhyVersions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.GetPhyVersions();

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPhyVersions() {
        return _getPhyVersions.apply(this, arguments);
      }

      return getPhyVersions;
    }()
  }]);
  return Configuration;
}();

var _default = Configuration;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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